<template>
  <div id="usermanage">
    <div class="content">
      <div class="button-group">
        <div class="button-title">用户列表</div>
        <div class="filling"></div>
        <el-button type="primary" size="small" @click="newUser"
          >添加新用户</el-button
        >
      </div>
      <el-table
        v-loading="loading"
        :data="tableData"
        height="calc(100% - 32px - var(--padding))"
      >
        <el-table-column prop="userName" label="姓名" min-width="120">
        </el-table-column>
        <el-table-column prop="email" label="邮箱" min-width="160">
        </el-table-column>
        <el-table-column prop="role" label="身份" min-width="100">
        </el-table-column>
        <el-table-column label="群组" min-width="100">
          <template slot-scope="scope">
            <span v-for="group in scope.row.groups" :key="group.groupName">{{
              group.groupName
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="detail" label="备注" min-width="200">
        </el-table-column>
        <el-table-column label="操作" width="90">
          <template slot-scope="scope">
            <el-tooltip
              content="修改"
              :visible-arrow="false"
              placement="top"
              effect="light"
              :open-delay="1000"
              :enterable="false"
              :hide-after="2500"
              transition="el-fade-in"
              popperClass="tooltip-config"
            >
              <i
                class="el-icon-ga-bianji icon-button"
                v-if="!scope.row.dir"
                @click="setUser(scope.row)"
              ></i>
            </el-tooltip>
            <el-tooltip
              content="删除"
              :visible-arrow="false"
              placement="top"
              effect="light"
              :open-delay="1000"
              :enterable="false"
              :hide-after="2500"
              transition="el-fade-in"
              popperClass="tooltip-config"
            >
              <i
                class="el-icon-ga-shanchu delete-icon icon-button"
                @click="deleteUser(scope.row)"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page-trun
      :disabled="loading"
      :page="page"
      :queryData="queryData"
      @pageTrun="pageTrun"
    />
    <user-dialog
      :dialog.sync="dialog"
      :dialogData="dialogData"
      @refush="refush"
    />
  </div>
</template>

<script>
import userDialog from "./dialog.vue";
import { Delete } from "@/utils/index";
export default {
  name: "usermanage",
  data() {
    return {
      loading: false,
      dialog: false,
      page: {
        pageIndex: 1,
        hasMore: false
      },
      dialogData: null,
      queryData: {}
    };
  },
  computed: {
    tableData() {
      return this.queryData[this.page.pageIndex];
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      this.$http
        .get("/gavial/v1/manage/sys/ad/users?pageIndex=" + this.page.pageIndex)
        .then(res => {
          this.$set(this.queryData, res.data.pageIndex, res.data.data);
          this.page = {
            pageIndex: res.data.pageIndex,
            hasMore: res.data.hasMore
          };
        })
        .finally(() => {
          this.loading = false;
        });
    },
    deleteUser(row) {
      let url = "/gavial/v1/manage/sys/ad/user/" + row.userId;
      if (row.role === "ADMIN") {
        url = "/gavial/v1/manage/sys/admin/" + row.userId;
      }
      Delete(url, row.userName, this.refush, bool => {
        this.loading = bool;
      });
    },
    newUser() {
      this.dialogData = null;
      this.dialog = true;
    },
    setUser(row) {
      this.dialogData = row;
      this.dialog = true;
    },
    pageTrun(i) {
      this.page.pageIndex = i;
      if (!this.queryData[this.page.pageIndex]) {
        this.getData();
      }
    },
    refush() {
      this.queryData = {};
      this.page.pageIndex = 1;
      this.page.hasMore = false;
      this.getData();
    }
  },
  components: {
    userDialog
  }
};
</script>

<style lang="scss" scoped>
#usermanage {
  height: 100%;
  .content {
    background: #ffffff;
    padding: var(--padding);
    height: calc(100% - 32px - var(--padding) * 2);
  }
}
</style>
